import React from 'react';

import { Box, Card, Container, Heading } from '@brand/components';

interface IGeneralLayoutOrganismProps {
  children: React.ReactNode;
  title: string;
}

const GeneralLayoutOrganism = ({
  children,
  title,
}: IGeneralLayoutOrganismProps): JSX.Element => {
  return (
    <Container maxW="container.lg">
      <Box>
        <Card borderRadius="3xl" padding={0} px={[10, 20, 32, 60]} py={20}>
          <Box mb={8} textAlign="center">
            <Heading fontWeight="bold" variant="h4">
              {title}
            </Heading>
          </Box>
          {children}
        </Card>
      </Box>
    </Container>
  );
};

export default GeneralLayoutOrganism;
